import { Cta as HygraphCtaProps, Maybe as HygraphMaybe } from '@/lib/types';

import { CTAProps } from '@/components/cta';
import { LinkProps } from '@/components/link';

import backgroundColorTransformer from '@/hygraph/transformers/background-color.transformer';

import linkTransformer from './link.transformer';

export default function CTATransformer(
  hygraphCTAProps: HygraphMaybe<HygraphCtaProps> | undefined
): CTAProps | undefined {
  if (!hygraphCTAProps) return undefined;
  const { title, text, link, full, backgroundColor } = hygraphCTAProps;

  return {
    title: title || '',
    text: text || undefined,
    link: linkTransformer(link) as LinkProps,
    full: full || undefined,
    backgroundColor: backgroundColorTransformer(backgroundColor),
  };
}
